import React, { Component } from 'react';
// import SaveTemplate from '../../assets/Save-template.png';
// import EditTemplate from '../../assets/Edit-template.png';
import globalVariables from "../../custom_libraries/globalVariables";
import urls from '../../custom_libraries/urls';
import { get, post } from '../../custom_libraries/serverRequests';
import { Button} from '@mui/material';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import { Link } from 'react-router-dom';

class SetHealthTemplateToDevice extends Component {
    constructor(props) {
        super(props);
        this.state = {
            template_name : '',
            template_hours : '',
            template_days : '',
            searchInput: '',
            currentPage: 1,
            rowsPerPage: 15,
            devices:[],
            selectedIds: [],
            showModal: false, // Controls modal visibility
            template_list: [],
            Responsemessage:'',
            success: false,
            error: false,
            warning: false,
        }
    }
    componentDidMount() {
        this.getDevicesList();
        this.handleFetchTemplate();
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.state.warning !== prevState.warning ||
            this.state.error !== prevState.error ||
            this.state.success !== prevState.success
        ) {
            if (
                this.state.warning ||
                this.state.error ||
                this.state.success
            ) {
                setTimeout(() => {
                    this.setState({
                        warning: false,
                        error: false,
                        success: false,
                    });
                }, 3000); // 1 second
            }
        }
    }

    handleInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

      getDevicesList = async () => {
        try {
          let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
          console.log("--------auth tocken---------", access_tocken);
          let headers = {
              'content-type': 'application/json',
              'Authorization': `Bearer ${access_tocken}`
          }
          // const response = await get(urls.GET_DEVICES, headers); // API call
          const response = await get(urls.GET_DEVICE_BY_DEALER, headers); //Api for devices w.r.t dealer's registered sites.
          console.log("API Response:", response)
    
          if (response) {
            console.log("res",response)
            this.setState({ devices: response });
            // this.setState({ devices:deviceData });
            // this.setState({ deviceId:deviceData.id });
          } else {
            console.error("No data returned from the API");
          }
        } catch (error) {
          console.error("Error fetching devices from API:", error);
        }
      };

    handleCheckboxChange = (id) => {
        this.setState((prevState) => {
            const { selectedIds } = prevState;
            console.log("selectedIds before update:", selectedIds);
            if (selectedIds.includes(id)) {
                return {
                    selectedIds: selectedIds.filter((selectedId) => selectedId !== id),
                };
            } else {
                return {
                    selectedIds: [...selectedIds, id],
                };
            }
        }, () => {
            // Callback after state update is complete
            console.log("selectedIds after update:", this.state.selectedIds);
        });
    };
      
    handleSearchInputChange = (e) => {
        this.setState({ searchInput: e.target.value });
    };

    handleSetTemplateClick = async () => {
        this.setState({
            showModal: true,
        });
    }

    // Method to handle modal close
    handleCloseModal = () => {
        this.setState({ showModal: false }, () => {
            // Reload the page after modal is closed
            // window.location.reload();
            this.getDevicesList();
        });
    };

    handleFetchTemplate = async() => {

        try{
            let response = await get(urls.HEALTH_RECORDING_POLICY);
            console.log("FetchTemplate API Response:", response)
            if (response) {
                console.log("res",response)
                this.setState({ template_list: response });
            } else {
                console.error("No data returned from the API");
                this.setState({ template_list: [] });
            }
        }

        catch (error) {
            console.error("Error fetching devices from API:", error);
        }
    }

    handleUpdateTemplate = async() => {
        const{selectedIds, template_name} = this.state;
        // Validation for required fields
        if (!selectedIds || !template_name) {
            this.setState({ warning: true });
            return;
        }
         let post_data = {
                    "device_ids" : selectedIds,
                    "recording_policy_id" : template_name,
                }
        
                post_data = JSON.stringify(post_data);
                console.log("------post-data in SaveTemplate---", post_data);
        
                try{
                    let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
                    console.log("--------auth tocken---------", access_tocken);
                    let headers = {
                        // 'content-type': 'application/json',
                        'Content-Type': 'application/json; charset=UTF-8',
                        // 'Authorization': `Bearer ${access_tocken}`
                    }
                    let response = await post(urls.SET_TEMPLATE_TO_MULTIPLE_DEVICES, post_data, headers);
                    console.log("API Response:", response)
                    
                    if(response && response.error==="device_ids and recording_policy_id are required."){
                        this.setState({ warning: true});
                        console.log("res",response);
                    }else if (response && response.error!=="device_ids and recording_policy_id are required.") {
                        this.setState({ success: true, Responsemessage: response.message });
                    }
                     else {
                        console.error("No response returned from the API");
                        this.setState({ error: true });
                        // setTimeout(() => {
                        //     window.location.reload();
                        // }, 3000); // 3 seconds delay
                    }
                }
        
                catch (error) {
                    console.error("Error fetching devices from API:", error);
                }
    }

    render(){
        const { currentPage, rowsPerPage, searchInput, devices, selectedIds, showModal, template_list, template_name, error, success, warning, Responsemessage, error1} = this.state;
        // Filter devices based on search input
        // Ensure devices is an array
        const filteredDevices = (Array.isArray(devices) ? devices : []).filter((device) =>
        device.device_name?.toLowerCase().includes(searchInput?.toLowerCase() ?? "")
      );
    
        // Pagination logic
        const indexOfLastRow = currentPage * rowsPerPage;
        const indexOfFirstRow = indexOfLastRow - rowsPerPage;
        const currentRows = filteredDevices.slice(indexOfFirstRow, indexOfLastRow);

        return(
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{height:'40px', backgroundColor:'#f3f3f3', color:'black', marginLeft: '11%', fontSize:'16px', fontWeight:'bold', display:'flex', alignItems:'center', marginBottom:'8px'}}>
                    <Link to="/system-overview"><span style={{ paddingLeft:'20px'}}>Dashboard</span> </Link>&ensp; &gt; &ensp;Device Manager &ensp;&gt;&ensp; Set Policy Template To Device(s)
                </div>
                <div className="home-container" style={{ display: 'flex', flex: '1', overflow: 'hidden', height: '100vh', paddingLeft: '5px' }}>
                    <div style={{ flex: '5', marginLeft: '13%', padding: '20px', overflowY: 'auto' }}>
                        <div>
                            <div className="search-container">
                                <span>
                                    <Button style={{border:'1px solid blue'}} onClick={this.handleSetTemplateClick}> Select and Apply Template </Button>
                                </span>
                                
                                <input
                                type="text"
                                id="search-input"
                                placeholder="Search by user name"
                                value={searchInput}
                                onChange={this.handleSearchInputChange}
                                />
                            </div>
                            <div>
                            <div>
                                <table id="devices" style={{ width: "100%", minWidth: "900px", borderCollapse: "collapse", marginBottom:'15px', textAlign:'center' }}>
                                    <thead>
                                        <tr>
                                        <th>Select</th>
                                        <th>Device Name</th>
                                        <th> IP </th>
                                        {/* <th>Device Timezone</th> */}
                                        <th>Template Name</th>
                                        {/* <th>Hours</th> */}
                                        <th>Days</th>
                                        <th>HDD Capacity</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentRows.map((device) => {
                                                            
                                            return (
                                            <tr key={device.id}>
                                                <td>
                                                    <input
                                                    type="checkbox"
                                                    checked={selectedIds.includes(device.id)}
                                                    onChange={() => this.handleCheckboxChange(device.id)}
                                                    />
                                                </td>
                                                <td>{device.device_name || ''}</td>
                                                <td>{device.ip_address || ''}</td>
                                                {/* <td>{device.device_time || ''}</td> */}
                                                <td>{device.recording_policy_name || ''}</td>
                                                {/* <td>{device.recording_policy_hours || ''}</td> */}
                                                <td>{device.recording_policy_days || ''}</td>
                                                <td>{device.hd_capacity_alert} </td>
                                            </tr>
                                            );
                                        })}
                                        {currentRows.length === 0 && (
                                        <tr>
                                            <td colSpan="6" style={{ textAlign: "center", padding: "20px" }}>
                                            No user found.
                                            </td>
                                        </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            

                            </div>
                            <div style={{ marginTop:'2.2cm', display: 'flex', justifyContent: 'center', marginBottom: '2.2cm' }}>
                                <button id ='rowsPerPageButton' onClick={() => this.handleChangePage(currentPage - 1)} disabled={currentPage === 1}>
                                    {"< Prev"}
                                </button>&emsp;
                                <span style={{fontSize:'small'}}>
                                    {`Page ${currentPage} / ${Math.ceil(filteredDevices.length / rowsPerPage)}`}
                                </span>&emsp;
                                <button id ='rowsPerPageButton' onClick={() => this.handleChangePage(currentPage + 1)} disabled={currentPage === Math.ceil(filteredDevices.length / rowsPerPage)}>
                                    {"Next >"}
                                </button>
                            </div>
                        </div>
                        {showModal && (
                        <div className="modal-set-template">
                            
                            <div className="modal-content-set-template">
                            { error ? (
                                        <Alert severity="error">Server Error! template is not set.</Alert>
                                    ) : success ? (
                                        <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                                            {Responsemessage}
                                        </Alert>
                                    ) : warning ? (<Alert  severity="warning">Please Select Device/s or Template!</Alert>)
                                        : null}
                                <span className="close-button" onClick={this.handleCloseModal}>
                                    &times;
                                </span>
                                
                                <h4 style={{ backgroundColor:'#dfecff', padding:'3px'}}>Update Template Name</h4>
                                <p style={{fontFamily: "Arial, sans-serif", fontSize:'14px'}}>You are about to set/update the template for selected devices</p>
                                
                                <div>
                                <select
                                    name="template_name"
                                    value={template_name}
                                    onChange={this.handleInputChange}
                                    style={{fontFamily: "Arial, sans-serif", fontSize:'16x'}}
                                    >
                                            
                                            <option value="" disabled>Select Template to view</option>
                                            {(template_list|| []).map((temp) => (
                                        <option key={temp.id} value={temp.id}>
                                            {temp.name}
                                        </option>
                                    ))}
                                    </select>
                                    <Button style={{color:'green'}} onClick={this.handleUpdateTemplate}>Set Template</Button>&nbsp;
                                    {/* <Button style={{color:'red'}}>Cancel</Button> */}
                                </div>
                            </div>
                        </div>
                    )}
                    
                    </div>
                    
                </div>
            </div>
        )
    }
    }
    
    export default SetHealthTemplateToDevice;